var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 64,
    viewBox: "0 0 77 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.0908,
    height: 63.7105,
    rx: 9.28524,
    fill: "#0E6AC7",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5999 9.28516H20.491C17.7325 9.28516 15.4755 11.5422 15.4755 14.3007V49.4096C15.4755 52.1682 17.7325 54.4252 20.491 54.4252H55.5999C58.3585 54.4252 60.6155 52.1682 60.6155 49.4096V14.3007C60.6155 11.5422 58.3585 9.28516 55.5999 9.28516ZM55.5999 49.4096H20.491V14.3007H55.5999V49.4096ZM25.5066 26.8396H30.5221V44.394H25.5066V26.8396ZM35.5377 19.3163H40.5532V44.394H35.5377V19.3163ZM45.5688 34.3629H50.5844V44.394H45.5688V34.3629Z",
    fill: "#062C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/Assessment.48a2ed5be6560870709ff588caf8186a.svg";
export { ForwardRef as ReactComponent };